import * as yup from 'yup';
import { getPhoneCountryByCode } from '../../constants/phone-country.constants';

export const schemaValidate = yup.object().shape({
  firstName: yup
    .string()
    .trim()
    .required('名字を入力してください')
    .max(100, '名字は100文字以内で入力してください'),

  lastName: yup
    .string()
    .trim()
    .required('名前を入力してください')
    .max(100, '名前は100文字以内で入力してください'),

  firstName_yomi: yup
    .string()
    .trim()
    .required('名字（フリガナ）を入力してください')
    .matches(/^[ァ-ヶー\s]+$/, '名字（フリガナ）はカタカナで入力してください')
    .max(100, '名字（フリガナ）は100文字以内で入力してください'),

  lastName_yomi: yup
    .string()
    .trim()
    .required('名前（フリガナ）を入力してください')
    .matches(/^[ァ-ヶー\s]+$/, '名前（フリガナ）はカタカナで入力してください')
    .max(100, '名前（フリガナ）は100文字以内で入力してください'),

  userName: yup
    .string()
    .trim()
    .required('ログイン名を入力してください')
    .matches(/^[a-zA-Z0-9_.]+$/, 'ログイン名はアルファベットで入力してください')
    .max(100, 'ログイン名は100文字以内で入力してください'),

  email: yup
    .string()
    .trim()
    .required('メールアドレスを入力してください')
    .email('有効なメールアドレスを入力してください')
    .max(100, 'メールアドレスは100文字以内で入力してください'),

  password: yup
    .string()
    .required('パスワードを入力してください')
    .min(8, 'パスワードは8桁以上で入力してください')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])/,
      'パスワードは8桁以上・数字・大文字・小文字と記号を含めて入力してください'
    )
    .max(100, 'パスワードは100文字以内で入力してください'),

  passwordConfirm: yup
    .string()
    .required('パスワードを再度入力してください')
    .oneOf([yup.ref('password')], 'パスワードが一致しません'),

  phoneCountryCode: yup
    .string()
    .required('国コードを選択してください'),

  phoneNumber: yup
    .string()
    .trim()
    .required('電話番号を入力してください')
    .matches(/^[0-9\s]+$/, '電話番号を正しく入力してください')
    .test('phone-length', '電話番号を正しく入力してください', function (value) {
      const country = getPhoneCountryByCode(this.parent.phoneCountryCode);
      if (!value || !country) {
        return true;
      }

      const digits = value.replace(/\D/g, '');
      return digits.length <= country.maxLength && digits.length >= 8;
    }),

  org: yup.string().required('組織を選択してください'),
});
